import React, { Component } from 'react';
import Stepper from 'react-stepper-horizontal';
import { setStage } from 'components/admin/general-contractors/store/actions';
import { connect } from 'react-redux';
import { getCurrentStage } from 'components/admin/general-contractors/store/selectors';

class OnboardingStatus extends Component {
  handleStageChange = (value) => {
    this.props.dispatch(setStage(value));
  };

  render() {
    return (
      <Stepper
        steps={[
          {
            title: 'Contractor License',
            href: null,
            onClick: () => {
              this.handleStageChange('licence-input');
            },
          },
          {
            title: 'Company Logo ',
            href: null,
            onClick: () => {
              this.handleStageChange('logo-upload');
            },
          },
        ]}
        size={16}
        lineMarginOffset={0}
        activeStep={this.props.activeStep}
        activeColor={'#ef4b3d'}
        completeColor={'#ef4b3d'}
        defaultColor={'#cecece'}
        circleFontSize={0}
        completeBarColor={'#3c4249'}
        defaultBarColor={'#cecece'}
      />
    );
  }
}

export default connect((state) => {
  return {
    currentStage: getCurrentStage(state),
  };
})(OnboardingStatus);



// WEBPACK FOOTER //
// ./src/components/admin/general-contractors/OnboardingStatus.js